<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createPcloudConfig } from "./fs";
  import { makeFileSystemPcloud, pcloudLogin } from "./fs-pcloud";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createPcloudConfig());
  let password = $state("");
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.email.trim() != "" && password != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("logging in to pCloud");
    try {
      config.email = config.email.trim();
      let res = await pcloudLogin(config.email, password);
      config.auth = res.auth;
      config.host = res.host;
      config.name = config.name.trim() || config.email;
      let fs = makeFileSystemPcloud(config);
      telegramNotify(`New pCloud connection for ${config.email}`);
      captureEvent("pcloud-login", { host: config.host });
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect pCloud">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-pcloud-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-pcloud-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-pcloud-email">Email:</label>
      <input
        type="text"
        id="input-pcloud-email"
        autocomplete="username"
        class="outline-hidden border px-2 py-1"
        bind:value={config.email}
      />

      <label class="mt-3" for="input-pcloud-password">Password:</label>
      <input
        type="password"
        id="input-pcloud-password"
        autocomplete="current-password"
        class="outline-hidden border px-2 py-1"
        bind:value={password}
      />

      <div class="mt-3 w-72 text-gray-500">
        The password goes only to pCloud. Sumatra File Manager Online keeps the login token.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect pCloud</button>
    </div>
  {/snippet}
</DialogBase>
